<script lang="ts">
  import AddMissingProduct from "@retailer/svelte/ProductLines/AddMissingProduct.svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import ProductContainerLookups from "@shared/services/product_container_lookups";
  import { parseSizeUnits, create } from "@shared/services/product";

  export let showModal = false;
  export let productLineId = null;

  const Product = {
    create,
    parseSizeUnits,
  };

  const services = {
    Product: Product,
    ProductTypes: null,
    ProductContainerLookups: ProductContainerLookups(),
  };

  const goToProduct = function (productLineId) {
    window["stateService"].go(
      "layout.product_detail",
      { productId: productLineId },
      { reload: true },
    );
  };

  const closeModal = function () {
    showModal = false;
  };
</script>

<Modal bind:show={showModal} fizzModal={false} size={"large"}>
  <div class="add-product-modal">
    <AddMissingProduct {services} {closeModal} {goToProduct} {productLineId} />
  </div>
</Modal>
